import Vue from 'vue'
import utils from './utils.js'

Vue.filter("arrToStr", function (value, columnKey) {
    if (!utils.isArray(value)) return value;

    let ret = [];
    if (utils.isEmpty(columnKey)) {
        ret = value;
    } else {
        value.forEach(function (item) {
            if (!utils.isEmpty(item[columnKey])) ret.push(item[columnKey]);
        })
    }

    return ret.join('、')
});
